// extracted by mini-css-extract-plugin
module.exports = {"lightbox":"b-RTKv","label":"_3zXLqy","info":"t42L5n mz-default-dark-font","question":"_1kv98q mz-default-dark-font","buttons":"EFQKIt","button":"_1QRDSs"};